/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditUnderSecretaryDecisionCommand } from '../../models/edit-under-secretary-decision-command';
import { EditUnderSecretaryDecisionCommandResult } from '../../models/edit-under-secretary-decision-command-result';

export interface ApiTaskEditUnderSecretaryDecisionPut$Params {
      body?: EditUnderSecretaryDecisionCommand
}

export function apiTaskEditUnderSecretaryDecisionPut(http: HttpClient, rootUrl: string, params?: ApiTaskEditUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskEditUnderSecretaryDecisionPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>;
    })
  );
}

apiTaskEditUnderSecretaryDecisionPut.PATH = '/api/Task/EditUnderSecretaryDecision';
